import request from '@/utils/request'

/**
 * 获取店铺广告列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listMallAd(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallAd.listMallAd',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增店铺广告
 * @param {Object} data 广告数据
 * @returns {Promise} Promise对象
 */
export function saveMallAd(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallAd.saveMallAd',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改店铺广告
 * @param {Object} data 广告数据
 * @returns {Promise} Promise对象
 */
export function updateMallAd(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallAd.updateMallAd',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除店铺广告
 * @param {Object} data 广告数据
 * @returns {Promise} Promise对象
 */
export function deleteMallAd(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallAd.deleteMallAd',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}